// extracted by mini-css-extract-plugin
export default {"message":"Message_message__J4lAY"};